import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/api-explorer")({
  component: ApiExplorerLayout,
});

function ApiExplorerLayout() {
  return <Outlet />;
}
